module.exports = __webpack_public_path__ + "img/nav-logo-2.8411408a.png";